import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import TuneIcon from '@mui/icons-material/Tune';
import { Card, CardContent } from '_template';
import SettingLayout from 'modules/Setting/components/SettingLayout';
import SettingTitle from 'modules/Setting/components/SettingTitle';
import ProjectSetting from './ProjectSetting';
import SettingValue from 'modules/Setting/components/SettingValue';

const SettingBasic = () => {
  const { t } = useTranslation();

  return (
    <SettingLayout>
      <SettingTitle icon={<TuneIcon />}>
        <Trans>SETTING.BASIC</Trans>
      </SettingTitle>
      <Card>
        <CardContent>
          <SettingValue label={t('SETTING.PROJECT')}>
            <ProjectSetting />
          </SettingValue>
        </CardContent>
      </Card>
    </SettingLayout>
  );
};

export default SettingBasic;
